import { TriggerType } from '@pushly/models/lib/enums/journeys'

export interface ITriggerFlags {
    isSubscribed: boolean
    isAbandonedCart: boolean
    isAbandonedView: boolean
    isAbandonment: boolean
    isSavedItem: boolean
    /**
     * True when the entry editor exposes the maximum item age control for this trigger type.
     * Both the control's visibility and the seeding of max_item_age_days into the trigger params
     * read this one flag, so a trigger can never display an age that the journey does not persist.
     */
    supportsMaxItemAgeDays: boolean
}

/**
 * Centralizes common trigger-type boolean checks used in rendering logic.
 * Pure utility with no side effects.
 */
export function getTriggerFlags(triggerType?: TriggerType): ITriggerFlags {
    const isSubscribed = triggerType === TriggerType.SUBSCRIBED
    const isAbandonedCart = triggerType === TriggerType.ABANDONED_CART
    const isAbandonedView = triggerType === TriggerType.ABANDONED_VIEW
    const isAbandonment = isAbandonedCart || isAbandonedView
    const isSavedItem = triggerType === TriggerType.SAVED_ITEM
    const supportsMaxItemAgeDays = isAbandonedCart || isSavedItem

    return {
        isSubscribed,
        isAbandonedCart,
        isAbandonedView,
        isAbandonment,
        isSavedItem,
        supportsMaxItemAgeDays,
    }
}
